module.exports = __webpack_public_path__ + "img/5@2x.4c88a5c6.png";